import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';

import { 
    defaultWMS1060_R01Dto, 
    defaultWMS1060_R01Filter, 
    WMS1060_R01Dto, 
    WMS1060_R01Filter 
} from './Dto_WMS1060_R01';

// Re-export for convenience
export type { WMS1060_R01Filter };
export { defaultWMS1060_R01Filter };

/**
 * WMS1060_R01 Store 인터페이스
 * 
 * 조회 전용 화면이므로 단순한 구조:
 * - Filter (검색 조건)
 * - List (조회 결과)
 * - ColumnState (그리드 상태)
 * - AllCount (전체 건수)
 */
export interface Store_WMS1060_R01 {
    // ========================================
    // 검색 조건
    // ========================================
    WMS1060_R01Filter: WMS1060_R01Filter;
    WMS1060_R01PastFilter: WMS1060_R01Filter;
    setWMS1060_R01Filter: (filter: Partial<WMS1060_R01Filter>) => void;
    setWMS1060_R01PastFilter: (filter: WMS1060_R01Filter) => void;
    
    // ========================================
    // 조회 결과
    // ========================================
    WMS1060_R01List: WMS1060_R01Dto[];
    setWMS1060_R01List: (dataList: WMS1060_R01Dto[]) => void;
    
    // ========================================
    // 그리드 컬럼 상태
    // ========================================
    columnState: ColumnState[] | null;
    setColumnState: (state: ColumnState[] | null) => void;
    
    // ========================================
    // 전체 건수
    // ========================================
    allCount: number;
    setAllCount: (count: number) => void;

    scrollTop: number | null;
    setScrollTop: (top: number | null) => void;
    
    // ========================================
    // 초기화
    // ========================================
    initData: () => void;
}

/**
 * Zustand Store 생성
 */
export const useWMS1060_R01Store = create<Store_WMS1060_R01>((set) => ({
    // 검색 조건
    WMS1060_R01Filter: defaultWMS1060_R01Filter,
    WMS1060_R01PastFilter: defaultWMS1060_R01Filter,
    setWMS1060_R01Filter: (update) => set((state) => ({
        WMS1060_R01Filter: {
            ...state.WMS1060_R01Filter,
            ...update
        }
    })),
    setWMS1060_R01PastFilter: (filter) => set({ WMS1060_R01PastFilter: filter }),
    
    // 조회 결과
    WMS1060_R01List: [],
    setWMS1060_R01List: (dataList) => {
        // valueIndex 자동 할당
        const listWithIndex = dataList.map((item, index) => ({
            ...item,
            valueIndex: index + 1
        }));
        return set({ WMS1060_R01List: listWithIndex });
    },
    
    // 그리드 컬럼 상태
    columnState: null,
    setColumnState: (state) => set({ columnState: state }),
    
    // 전체 건수
    allCount: 0,
    setAllCount: (count) => set({ allCount: count }),

    scrollTop: null,
    setScrollTop: (top) => set({ scrollTop: top }),
    
    // 초기화
    initData: () => set({
        WMS1060_R01Filter: defaultWMS1060_R01Filter,
        WMS1060_R01PastFilter: defaultWMS1060_R01Filter,
        WMS1060_R01List: [],
        columnState: null,
        allCount: 0,
        scrollTop: null,
    }),
}));
